export default __webpack_public_path__ + "static/media/documentacion.e24df254.svg";